import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import UITileSection from 'UIComponents/tile/UITileSection';
import AccordionTree from 'automation-ui-enrollment/components/common/jsonView/AccordionTree';
import UIButton from 'UIComponents/button/UIButton';
import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledTile = styled(UITile).withConfig({
  displayName: "WebhookPayloadContainer__StyledTile",
  componentId: "alu4t1-0"
})(["overflow-x:scroll;"]);
const hasNestedPayload = obj => {
  return Object.values(obj).some(val => typeof val === 'object' && val !== null);
};
const WebhookPayloadContainer = ({
  webhookData,
  children
}) => {
  const [areAllBranchesOpen, setAllBranchesOpen] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, /*#__PURE__*/_jsxs(StyledTile, {
      compact: true,
      className: "width-100",
      children: [/*#__PURE__*/_jsx(UITileSection, {
        className: "p-bottom-0",
        children: hasNestedPayload(webhookData['response']) && /*#__PURE__*/_jsx(UIButton, {
          className: "p-left-0 m-bottom-2 m-top-0",
          onClick: () => setAllBranchesOpen(!areAllBranchesOpen),
          size: "xs",
          use: "transparent",
          children: areAllBranchesOpen ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.connectingApp.payload.collapseAllBranches"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.connectingApp.payload.openAllBranches"
          })
        })
      }), /*#__PURE__*/_jsx(UITileSection, {
        className: "p-top-0",
        children: /*#__PURE__*/_jsx(AccordionTree, {
          areAllBranchesOpen: areAllBranchesOpen,
          dataObject: webhookData.response
        })
      })]
    })]
  });
};
export default WebhookPayloadContainer;